export default "__VITE_ASSET__GmtA8VuW__"